// AgentVerse/client/mainLayout.js


export default {
    defaultRoute: '/entry/login',
    defaultRoutes: {
        public: '/entry/login',       // Default for public users
        user: '/user/dashboard',  // Default for logged-in 'user'
        admin: '/admin/dashboard',// Default for logged-in 'admin'
        login: '/entry/login',    // Login page route
        entry: '/entry',          // Base for authentication flow
    },

    layers: {
        "base": {
            template: `<div id="root-container-wrapper" class="vh-100">
                         <div id="dev-tools-container"></div>
                       </div>`,
            container: 'root-container',
            components: [
                { name: 'entry', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'app', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'error', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container', instanceId: 'agentVerseDevTools' },
                { name: 'remote-desktop-viewer', type: 'RemoteDesktopViewer', container: 'root-container-wrapper', instanceId: 'agentVerseRdv' },
            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="ab-entry-page">
                    <div id="entry-titlebar-controls" class="electron-only-titlebar-host w-100 d-flex justify-content-end pe-2" style="position: absolute; top: 0; left: 0; height: 48px; -webkit-app-region: drag; z-index: 9999;">
                        <div id="entry-titlebar-controls-target" class="h-100" style="-webkit-app-region: no-drag;"></div>
                    </div>
                    <div class="ab-entry-branding">
                        <div id="entry-branding-logo" class="mb-4"></div>
                        <h1 class="ab-entry-headline" data-i18n="Access Your Digital Workforce">Access Your Digital Workforce</h1>
                        <p class="ab-entry-subline" data-i18n="Log in to command your team of AI agents, automate workflows, and monitor your business operations from a single, unified dashboard.">Log in to command your team of AI agents, automate workflows, and monitor your business operations from a single, unified dashboard.</p>
                        <ul class="ab-entry-features">
                            <li>
                                <i class="bi bi-folder2-open"></i>
                                <div>
                                    <strong data-i18n="Organized Projects">Organized Projects:</strong>
                                    <span data-i18n="Keep your agents, data, and workflows neatly organized in dedicated project spaces.">Keep your agents, data, and workflows neatly organized in dedicated project spaces.</span>
                                </div>
                            </li>
                            <li>
                                <i class="bi bi-robot"></i>
                                <div>
                                    <strong data-i18n="Powerful Automation">Powerful Automation:</strong>
                                    <span data-i18n="Deploy autonomous agents that can make phone calls, manage systems, and operate any web application.">Deploy autonomous agents that can make phone calls, manage systems, and operate any web application.</span>
                                </div>
                            </li>
                            <li>
                                <i class="bi bi-shield-check"></i>
                                <div>
                                    <strong data-i18n="Total Control & Security">Total Control & Security:</strong>
                                    <span data-i18n="Manage user roles, protect sensitive data, and scale your operations with confidence.">Manage user roles, protect sensitive data, and scale your operations with confidence.</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="ab-entry-card-container">
                        <div class="ab-entry-card">
                            <div id="entry-mobile-logo" class="ab-entry-mobile-logo"></div>
                            <div id="entry-component-target"></div>
                            <div class="ab-entry-card-footer">
                                <a href="/entry/login" data-i18n="Login">Login</a>
                                <span>·</span>
                                <a href="/entry/signup" data-i18n="Sign Up">Sign Up</a>
                                <span>·</span>
                                <a href="/entry/forgot-password" data-i18n="Forgot Password">Forgot Password</a>
                            </div>
                        </div>
                    </div>
                    <div class="ab-entry-terms">
                        By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.
                    </div>
                </div>
            `,
            components: [
                { name: 'branding-logo', type: 'LogoComponent', container: 'entry-branding-logo', props: { logoText: 'WorxBots', iconClass: 'bi-bounding-box-circles' } },
                { name: 'mobile-logo', type: 'LogoComponent', container: 'entry-mobile-logo', props: { logoText: 'WorxBots', iconClass: 'bi-bounding-box-circles' } },
                { name: 'titlebar-controls-entry', type: 'TitleBarControls', container: 'entry-titlebar-controls-target' },
                { name: 'login-layer', type: 'layer', layer: 'login', container: 'entry-component-target', default: true },
                { name: 'signup-layer', type: 'layer', layer: 'signup', container: 'entry-component-target' },
                { name: 'forgotpassword-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-component-target' }
            ]
        },


        login: {
            route: '/entry/login',
            template: '<div id="login-form-content"></div>',
            components: [{ name: 'login-component', type: 'Login', container: 'login-form-content', instanceId: 'agentVerseLogin' }]
        },

        signup: {
            route: '/entry/signup',
            template: '<div id="signup-form-content"></div>',
            components: [{ name: 'signup-component', type: 'Signup', container: 'signup-form-content', instanceId: 'agentVerseSignup' }]
        },

        forgotpassword: {
            route: '/entry/forgot-password',
            template: '<div id="forgotpassword-form-content"></div>',
            components: [{ name: 'forgotpassword-component', type: 'ForgotPassword', container: 'forgotpassword-form-content', instanceId: 'agentVerseForgotPwd' }]
        },

        "common-header": {
            template: `
                <div class="d-flex justify-content-between align-items-center w-100 h-100" style="-webkit-app-region: drag;">
                    <!-- Left-aligned group: This container ensures vertical alignment -->
                    <div class="d-flex align-items-center gap-3 h-100" style="-webkit-app-region: no-drag;">
                        <div id="common-logo-target" class="ms-2"></div>
                        <!-- This border provides a nice visual separation -->
                        <div id="user-project-selector-target" class="border-start ps-3"></div> 
                    </div>

                    <!-- Right-aligned group -->
                    <div class="d-flex align-items-center h-100" style="-webkit-app-region: no-drag;">
                        <div id="agentverse-copilot-button-container" class="me-2"></div> 
                        <div id="common-role-switcher-container"></div>
                        <div id="common-runtime-progress-target"></div>
                        <div id="common-themes-target"></div>
                        <div id="common-notifications-target"></div>
                        <div id="documentation-link-container" class="me-2"></div>
                        <div id="common-user-menu-target"></div>
                        <div id="common-titlebar-controls" class="electron-only-titlebar-host h-100 ms-2"></div>
                    </div>
                </div>
            `,
            // The `components` array for common-header remains unchanged.
            components: [
                {
                    name: 'common-logo', type: 'LogoComponent', container: 'common-logo-target', instanceId: 'agentVerseLogo',
                    props: {
                        desktopLogoUrl: '/public/logo.png',
                        mobileLogoUrl: '/public/android-chrome-192x192.png',
                        desktopImageHeight: '35px'
                    }
                },
                { name: 'user-project-selector', type: 'ProjectSelector', container: 'user-project-selector-target', instanceId: 'userProjectSelector' },
                {
                    name: 'agentverse-copilot-button',
                    type: 'AgentVerseCopilot',
                    container: 'agentverse-copilot-button-container',
                    instanceId: 'headerAgentVerseCopilot',
                    props: {
                        agentName: "AgentVerseAssistant",
                        title: "AgentVerse Assistant",
                        buttonIcon: "bi-stars",
                        buttonClasses: "btn btn-outline-info btn-sm"
                    }
                },
                {
                    name: 'common-role-switcher', type: 'RoleSwitcher', container: 'common-role-switcher-container', instanceId: 'common-role-switcher',
                    props: {
                        roleIcons: {
                            admin: 'bi-shield-lock-fill',
                            courseAdmin: 'bi-person-video3',
                            parent: 'bi-people-fill',
                            student: 'bi-mortarboard-fill'
                        },
                    }
                },
                { name: 'runtime-progress', type: 'RuntimeProgressManager', container: 'common-runtime-progress-target', instanceId: 'agentVerseRuntimeProgress' },
                { name: 'common-notifications', type: 'Notifications', container: 'common-notifications-target', instanceId: 'agentVerseNotifications' },
                { name: 'documentation-link', type: 'DocumentationLink', container: 'documentation-link-container' },
                { name: 'common-user-menu', type: 'UserProfileMenu', container: 'common-user-menu-target', instanceId: 'agentVerseUserProfileMenu', props: { showThemeSelector: true, showRemoteDesktop: true, menuItems: [{ title: "Profile", route: "/user/profile" }] } },
                { name: 'titlebar-controls', type: 'TitleBarControls', container: 'common-titlebar-controls' }
            ]
        },

        app: {
            route: '/app',
            template: `
                <div id="app-wrapper" class="d-flex flex-column h-100">
                    <header id="shared-header-area" class="app-header border-bottom"></header>
                    <div id="app-body-area" class="flex-grow-1 overflow-hidden">
                        <!-- User or Admin layers will be mounted here -->
                    </div>
                </div>
            `,
            components: [
                { name: 'common-header-layer', type: 'layer', layer: 'common-header', container: 'shared-header-area' },
                { name: 'user-layer', type: 'layer', layer: 'user', container: 'app-body-area' },
                { name: 'admin-layer', type: 'layer', layer: 'admin', container: 'app-body-area' }
            ]
        },

        user: {
            route: '/user',
            template: `
                <div class="d-flex flex-row h-100">
                    <aside id="user-sidebar-target" class="app-sidebar border-end d-flex flex-column">
                        <div id="user-menu-target" class="flex-grow-1 overflow-auto"></div> <!-- AppMenu takes remaining space -->
                    </aside>
                    <main id="user-content-target" class="flex-grow-1 overflow-auto p-3"></main>
                </div>
            `,
            components: [
                { name: 'user-menu', type: 'AppMenu', container: 'user-menu-target', instanceId: 'userMenu', props: { dataSource: 'layoutEngine', startingRoute: '/user/', includeHidden: false, fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'user-content-switch', type: 'layer', layer: 'user-content', container: 'user-content-target', default: true },
            ]
        },

        'user-content': {
            template: `<div id="user-feature-area" class="h-100"></div>`,
            components: [
                { name: 'user-dashboard-layer', type: 'layer', layer: 'user-dashboard-layer', container: 'user-feature-area', default: true },
                { name: 'user-agents-layer', type: 'layer', layer: 'user-agents-layer', container: 'user-feature-area' },
                { name: 'user-agent-config-layer', type: 'layer', layer: 'user-agent-config-layer', container: 'user-feature-area' },
                { name: 'user-contacts-layer', type: 'layer', layer: 'user-contacts-layer', container: 'user-feature-area' },
                { name: 'user-tasks-layer', type: 'layer', layer: 'user-tasks-layer', container: 'user-feature-area' },
                { name: 'user-documentation-layer', type: 'layer', layer: 'user-documentation-layer', container: 'user-feature-area' },
                { name: 'user-participants-layer', type: 'layer', layer: 'user-participants-layer', container: 'user-feature-area' },
                { name: 'user-messaging-layer', type: 'layer', layer: 'user-messaging-layer', container: 'user-feature-area' },
                { name: 'user-workflows-layer', type: 'layer', layer: 'user-workflows-layer', container: 'user-feature-area' },
                { name: 'user-scheduler-layer', type: 'layer', layer: 'user-scheduler-layer', container: 'user-feature-area' },
                { name: 'user-secrets-layer', type: 'layer', layer: 'user-secrets-layer', container: 'user-feature-area' },
                { name: 'user-profile-layer', type: 'layer', layer: 'user-profile-layer', container: 'user-feature-area' },
            ]
        },

        'user-dashboard-layer': {
            route: '/user/dashboard', menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-house-door', menuOrder: 1,
            template: '<div id="user-dashboard-content" class="h-100"></div>',
            components: [{ name: 'user-dashboard', type: 'Dashboard', container: 'user-dashboard-content', instanceId: 'userDashboard' }]
        },

        'user-agents-layer': {
            route: '/user/agents', menuItem: true, menuTitle: 'Agents', menuIcon: 'bi-robot', menuOrder: 2,
            template: '<div id="user-agents-content" class="h-100"></div>',
            components: [{
                name: 'user-agent-manager', type: 'AgentManagerCrud', container: 'user-agents-content', instanceId: 'userAgentManagerCrud',
                props: {
                    agentConfigRoute: '/user/agent-config',
                }
            }]
        },

        'user-contacts-layer': {
            route: '/user/messaging-contacts', menuItem: true, menuTitle: 'Contacts', menuIcon: 'bi-people-fill', menuOrder: 3,
            template: '<div id="user-contacts-content" class="h-100"></div>',
            components: [{ name: 'user-messaging-contacts', type: 'MessagingContactsCrud', container: 'user-contacts-content', instanceId: 'userMessagingContactsCrud' }]
        },

        'user-participants-layer': {
            route: '/user/participants', menuItem: true, menuTitle: 'Participants', menuIcon: 'bi-people', menuOrder: 3.1,
            template: '<div id="user-participants-content" class="h-100"></div>',
            components: [{ name: 'project-participants-manager', type: 'ProjectParticipants', container: 'user-participants-content', instanceId: 'projectParticipantsManager' }]
        },

        'user-tasks-layer': {
            route: '/user/tasks', menuItem: true, menuTitle: 'Tasks', menuIcon: 'bi-check2-square', menuOrder: 4,
            template: '<div id="user-tasks-content" class="h-100"></div>',
            components: [{ name: 'project-tasks-component', type: 'ProjectTasks', container: 'user-tasks-content', instanceId: 'agentVerseProjectTasks' }]
        },

        'user-documentation-layer': {
            route: '/user/documentation', menuItem: true, menuTitle: 'Documentation', menuIcon: 'bi-book-half', menuOrder: 4,
            template: '<div id="user-documentation-content" class="h-100"></div>',
            components: [{ name: 'project-documentation-component', type: 'ProjectDocumentation', container: 'user-documentation-content', instanceId: 'agentVerseProjectDocs' }]
        },

        'user-agent-config-layer': {
            route: '/user/agent-config',
            hideInMenu: true, // Not directly in menu, accessed from agent list
            template: '<div id="user-agent-config-content" class="h-100"></div>',
            components: [{
                name: 'user-agent-config-view',
                type: 'AgentConfigurationView',
                container: 'user-agent-config-content',
                instanceId: 'agentConfigView',
                props: {
                    agentListRoute: '/user/agents'
                }
            }]
        },

        'user-messaging-layer': {
            route: '/user/messaging', menuItem: true, menuTitle: 'Messaging', menuIcon: 'bi-chat-dots-fill', menuOrder: 4,
            template: '<div id="user-messaging-content" class="h-100"></div>',
            components: [{ name: 'user-messaging-client', type: 'MessagingClient', container: 'user-messaging-content', instanceId: 'userMessagingClient' }]
        },

        'user-workflows-layer': {
            route: '/user/workflows', menuItem: true, menuTitle: 'Workflows', menuIcon: 'bi-diagram-3-fill', menuOrder: 5,
            template: '<div id="user-workflows-content" class="h-100"></div>',
            components: [{ name: 'user-workflow-crud', type: 'WorkflowCrud', container: 'user-workflows-content', instanceId: 'userWorkflowCrud' }]
        },

        'user-scheduler-layer': {
            route: '/user/scheduler', menuItem: true, menuTitle: 'Scheduler', menuIcon: 'bi-calendar-check-fill', menuOrder: 6,
            template: '<div id="user-scheduler-content" class="h-100"></div>',
            components: [{ name: 'user-scheduled-tasks', type: 'ScheduledTasks', container: 'user-scheduler-content', instanceId: 'userScheduledTasks' }]
        },

        'user-secrets-layer': {
            route: '/user/secrets', menuItem: true, menuTitle: 'Project Secrets', menuIcon: 'bi-key-fill', menuOrder: 7,
            template: '<div id="user-secrets-content" class="h-100"></div>',
            components: [{ name: 'user-secrets-manager', type: 'SecretsManager', container: 'user-secrets-content', instanceId: 'userSecretsManager', props: { customProject: true } }]
        },

        'user-profile-layer': {
            route: '/user/profile', hideInMenu: true,
            template: '<div id="user-profile-content" class="h-100"></div>',
            components: [{ name: 'user-profile-view', type: 'UserProfile', container: 'user-profile-content', instanceId: 'userProfileView' }]
        },

        admin: {
            route: '/admin',
            template: `
                <div class="d-flex flex-row h-100">
                    <aside id="admin-sidebar-target" class="app-sidebar border-end"></aside>
                    <main id="admin-content-target" class="flex-grow-1 overflow-auto p-3"></main>
                </div>
            `,
            components: [
                {
                    name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar-target', instanceId: 'adminMenu', props: {
                        startingRoute: '/admin/',
                        fullHeight: true,
                        collapsible: false,
                        defaultCollapsed: false,
                        saveState: true
                    }
                },
                { name: 'admin-content-switch', type: 'layer', layer: 'admin-content', container: 'admin-content-target', default: true },
            ]
        },

        'admin-content': {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'admin-dashboard-layer', type: 'layer', layer: 'admin-dashboard-layer', container: 'admin-feature-area', default: true },
                { name: 'admin-users-layer', type: 'layer', layer: 'admin-users-layer', container: 'admin-feature-area' },
                { name: 'admin-invite-codes-layer', type: 'layer', layer: 'admin-invite-codes', container: 'admin-feature-area' },
                { name: 'admin-global-secrets-layer', type: 'layer', layer: 'admin-global-secrets-layer', container: 'admin-feature-area' },
                { name: 'admin-ecosystem-layer', type: 'layer', layer: 'admin-ecosystem-layer', container: 'admin-feature-area' },
                { name: 'admin-user-config-layer', type: 'layer', layer: 'admin-user-config-layer', container: 'admin-feature-area' },

                // Add more admin-specific layers here if needed
            ]
        },

        'admin-dashboard-layer': {
            route: '/admin/dashboard', menuItem: true, menuTitle: 'Admin Dashboard', menuIcon: 'bi-speedometer2', menuOrder: 1,
            template: '<div id="admin-dashboard-content" class="h-100"></div>',
            components: [{ name: 'admin-dashboard', type: 'Dashboard', container: 'admin-dashboard-content', instanceId: 'adminDashboard' }]
        },

        'admin-global-secrets-layer': {
            route: '/admin/global-secrets', menuItem: true, menuTitle: 'Global Secrets', menuIcon: 'bi-shield-lock-fill', menuOrder: 3,
            template: '<div id="admin-global-secrets-content" class="h-100"></div>',
            components: [{ name: 'admin-global-secrets-manager', type: 'SecretsManager', container: 'admin-global-secrets-content', instanceId: 'adminGlobalSecretsManager', props: { customProject: false } }]
        },

        'admin-users-layer': {
            route: '/admin/users', menuItem: true, menuTitle: 'Manage Users', menuIcon: 'bi-people-fill', menuOrder: 2,
            template: '<div id="admin-users-content" class="h-100"></div>',
            components: [{ name: 'admin-users-crud', type: 'UserManager', container: 'admin-users-content', instanceId: 'adminUserManager' }]
        },

        'admin-ecosystem-layer': {
            route: '/admin/ecosystem',
            menuItem: true,
            menuTitle: 'Integrations',
            menuIcon: 'bi-diagram-3-fill',
            menuOrder: 4,
            template: '<div id="admin-ecosystem-content" class="h-100 p-3"></div>',
            components: [{
                name: 'admin-downstream-services',
                type: 'DownstreamServices',
                container: 'admin-ecosystem-content',
                instanceId: 'adminDownstreamServicesManager'
            }]
        },


        'admin-user-config-layer': { // New layer definition
            route: '/admin/user-config',
            hideInMenu: true, // Not directly in menu
            template: '<div id="admin-user-config-content" class="h-100"></div>',
            components: [{
                name: 'admin-user-config-view',
                type: 'UserConfigurationView',
                container: 'admin-user-config-content',
                instanceId: 'userConfigView'
            }]
        },
    }


};